import * as React from "react";
const MobileMenu = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#4F2E03"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M1.5 1.5h26M1.5 11h26m-26 9.5h26"
    />
  </svg>
);
export default MobileMenu;
